import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Row, Col, Typography, Switch, Space, Divider } from 'antd';
import { PageHeader, StandardSkeleton } from '@municipality/ui';

const { Title, Text } = Typography;

export const Settings: React.FC = () => {
  const { t } = useTranslation('settings');
  const isLoading = false; // TODO: Replace with actual loading state if available

  return (
    <div style={{ padding: '24px' }}>
      <PageHeader
        title={t('title')}
        subtitle={t('subtitle')}
      />
      
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title={t('platformSettings')} style={{ height: '100%' }}>
            <StandardSkeleton loading={isLoading} rows={3}>
              <Text>{t('platformSettings')} content will be implemented here.</Text>
            </StandardSkeleton>
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card title={t('globalSettings')} style={{ height: '100%' }}>
            <StandardSkeleton loading={isLoading} rows={3}>
              <Text>{t('globalSettings')} content will be implemented here.</Text>
            </StandardSkeleton>
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card title={t('manageGlobal') + ' ' + t('citiesAndAreas')} style={{ height: '100%' }}>
            <StandardSkeleton loading={isLoading} rows={3}>
              <Text>{t('citiesAndAreas')} management will be implemented here.</Text>
            </StandardSkeleton>
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card title={t('manageGlobal') + ' ' + t('citizenCategories')} style={{ height: '100%' }}>
            <StandardSkeleton loading={isLoading} rows={3}>
              <Text>{t('citizenCategories')} management will be implemented here.</Text>
            </StandardSkeleton>
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card title={t('manageGlobal') + ' ' + t('volunteerCategories')} style={{ height: '100%' }}>
            <StandardSkeleton loading={isLoading} rows={3}>
              <Text>{t('volunteerCategories')} management will be implemented here.</Text>
            </StandardSkeleton>
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card title={t('manageGlobal') + ' ' + t('poiCategories')} style={{ height: '100%' }}>
            <StandardSkeleton loading={isLoading} rows={3}>
              <Text>{t('poiCategories')} management will be implemented here.</Text>
            </StandardSkeleton>
          </Card>
        </Col>
      </Row>
      
      <Card style={{ marginBottom: 24 }}>
        <Title level={4}>Security Settings</Title>
        <StandardSkeleton loading={isLoading} rows={2}>
          <Space direction="vertical" style={{ width: '100%' }} size="large">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text strong>Biometric Authentication</Text>
                <br />
                <Text type="secondary">Use fingerprint or face recognition to sign in</Text>
              </div>
              <Switch />
            </div>
            
            <Divider />
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text strong>Two-Factor Authentication</Text>
                <br />
                <Text type="secondary">Add an extra layer of security to your account</Text>
              </div>
              <Switch />
            </div>
          </Space>
        </StandardSkeleton>
      </Card>
      
      <Card style={{ marginBottom: 24 }}>
        <Title level={4}>Administration Settings</Title>
        <StandardSkeleton loading={isLoading} rows={2}>
          <Space direction="vertical" style={{ width: '100%' }} size="large">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text strong>System Monitoring</Text>
                <br />
                <Text type="secondary">Enable real-time system monitoring</Text>
              </div>
              <Switch defaultChecked />
            </div>
            
            <Divider />
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text strong>Audit Logging</Text>
                <br />
                <Text type="secondary">Track all administrative actions</Text>
              </div>
              <Switch defaultChecked />
            </div>
          </Space>
        </StandardSkeleton>
      </Card>
      
      <Card>
        <Title level={4}>Notification Settings</Title>
        <StandardSkeleton loading={isLoading} rows={2}>
          <Space direction="vertical" style={{ width: '100%' }} size="large">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text strong>Email Notifications</Text>
                <br />
                <Text type="secondary">Receive updates via email</Text>
              </div>
              <Switch defaultChecked />
            </div>
            
            <Divider />
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text strong>Push Notifications</Text>
                <br />
                <Text type="secondary">Receive real-time updates</Text>
              </div>
              <Switch defaultChecked />
            </div>
          </Space>
        </StandardSkeleton>
      </Card>
    </div>
  );
};

export default Settings; 